import { useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import contactImg from '../assets/img/get-in-touch.png'
import 'animate.css'
import TrackVisibility from 'react-on-screen'
import emailjs from 'emailjs-com'
import { useRef } from 'react'

export const Contact = () => {
  const formInitialDetails = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: '',
  }
  const [formDetails, setFormDetails] = useState(formInitialDetails)
  const [buttonText, setButtonText] = useState('Send')
  const [status, setStatus] = useState({})
  const form = useRef()

  const onFormUpdate = (category, value) => {
    setFormDetails({
      ...formDetails,
      [category]: value,
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    emailjs.sendForm(
      'service_m4nkxkr',
      'template_l05nio8',
      form.current,
      'gXUuJqjiNi0LtLj9F'
    )
    if (
      formDetails.firstName &&
      formDetails.lastName &&
      formDetails.email &&
      formDetails.phone &&
      formDetails.message
    ) {
      setButtonText('Message sent successfully')
      return setFormDetails({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: '',
      })
    }

    if (buttonText === 'Message sent successfully') {
      setStatus({ succes: true, message: 'Message sent successfully' })
    } else {
      setStatus({
        succes: false,
        message: 'All fields must be completed.',
      })
    }
  }

  return (
    <section className='contact' id='connect'>
      <Container>
        <Row className='align-items-center'>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <img
                  className={
                    isVisible ? 'animate__animated animate__zoomIn' : ''
                  }
                  src={contactImg}
                  alt='Contact Us'
                />
              )}
            </TrackVisibility>
          </Col>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? 'animate__animated animate__fadeIn' : ''
                  }
                >
                  <h2>Get In Touch</h2>
                  <form onSubmit={handleSubmit} ref={form}>
                    <Row>
                      <Col size={12} sm={6} className='px-1'>
                        <input
                          type='text'
                          name='firstname'
                          value={formDetails.firstName}
                          placeholder='First Name'
                          onChange={(e) =>
                            onFormUpdate('firstName', e.target.value)
                          }
                        />
                      </Col>
                      <Col size={12} sm={6} className='px-1'>
                        <input
                          type='text'
                          value={formDetails.lastName}
                          name='lastname'
                          placeholder='Last Name'
                          onChange={(e) =>
                            onFormUpdate('lastName', e.target.value)
                          }
                        />
                      </Col>
                      <Col size={12} sm={6} className='px-1'>
                        <input
                          type='email'
                          value={formDetails.email}
                          name='email'
                          placeholder='Email Address'
                          onChange={(e) =>
                            onFormUpdate('email', e.target.value)
                          }
                        />
                      </Col>
                      <Col size={12} sm={6} className='px-1'>
                        <input
                          type='tel'
                          value={formDetails.phone}
                          name='phone'
                          placeholder='Phone No.'
                          onChange={(e) =>
                            onFormUpdate('phone', e.target.value)
                          }
                        />
                      </Col>
                      <Col size={12} className='px-1'>
                        <textarea
                          rows='6'
                          value={formDetails.message}
                          name='message'
                          placeholder='Message'
                          onChange={(e) =>
                            onFormUpdate('message', e.target.value)
                          }
                        ></textarea>
                        {status.message && (
                          <Col>
                            <p style={{ color: 'black' }}>{status.message}</p>
                          </Col>
                        )}
                        <button type='submit'>
                          <span>{buttonText}</span>
                        </button>
                      </Col>
                    </Row>
                  </form>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
